import React from 'react';

const Spinner = ({ size = 'md', color = 'blue', centered = false, overlay = false }) => {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const colorClasses = {
    blue: 'text-blue-500',
    white: 'text-white',
    gray: 'text-gray-500',
    indigo: 'text-indigo-500',
    purple: 'text-purple-500'
  };

  const spinnerElement = (
    <div className="relative">
      {/* Outer ring */}
      <div className={`${sizeClasses[size]} animate-spin`}>
        <div className={`absolute inset-0 rounded-full border-2 border-transparent border-t-current ${colorClasses[color]} opacity-75`}></div>
      </div>
      {/* Inner ring for professional look */}
      <div className={`absolute inset-1 ${sizeClasses[size === 'xs' ? 'xs' : size === 'sm' ? 'xs' : size === 'md' ? 'sm' : size === 'lg' ? 'md' : 'lg']} animate-spin`} style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}>
        <div className={`absolute inset-0 rounded-full border border-transparent border-t-current ${colorClasses[color]} opacity-50`}></div>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );

  if (overlay) {
    return (
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50">
        <div className="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center space-y-4">
          {spinnerElement}
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (centered) {
    return (
      <div className="flex items-center justify-center w-full h-full min-h-[200px]">
        {spinnerElement}
      </div>
    );
  }

  return spinnerElement;
};

export default Spinner;